var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-info"},[_c('p',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.pageTitle))]),_c('p',{staticClass:"greeting"},[_vm._v(_vm._s(_vm.greeting))]),_c('div',{staticClass:"divider"})])}
var staticRenderFns = []

export { render, staticRenderFns }